import { PlaycastMessage, PlaycastMessageTarget } from '../types';

export * as system from './system';
export * as remote from './remote';
export * as host from './host';
export * as gamepad from './gamepad';
export * as camera from './camera';
export * as process from './process';
export * as overlay from './overlay';
export * as encoder from './encoder';
export * as input from './input';
export * as hub from './hub';
export * as touch from './touch';

export const validatePlaycastMessage = (message: string | Record<string, unknown>): PlaycastMessage<PlaycastMessageTarget> | undefined => {
  let msgTarget = 'unknown';
  let msgAction = 'unknown';
  const fail = (field: string) => {
    console.error(`Failed to validate message: ${field} is required. Target: ${msgTarget}, Action: ${msgAction}`);
    return undefined;
  };

  if (typeof message === 'string') {
    try {
      message = JSON.parse(message);
    } catch (err) {
      console.error('Failed to parse message:', message);
      return undefined;
    }
  }
  const messageObj = message as PlaycastMessage<PlaycastMessageTarget>;
  // console.log('[validatePlaycastMessage] messageObj:', messageObj);
  // Check required fields.
  try {
    const header = messageObj['header'];
    if (header === undefined) return fail('header');
    const body = messageObj['body'];
    if (body === undefined) return fail('body');

    // const CHANCE_TO_LOG_TIMESTAMP = 0.1;
    // if (Math.random() < CHANCE_TO_LOG_TIMESTAMP) {
    //   if (typeof header['timestamp'] !== 'string') {
    //     const localLatency = Date.now() - header['timestamp'];
    //     console.log(`[PING] Local: ${localLatency}ms`);
    //   }
    // }

    msgTarget = header['target'] || 'unknown';
    msgAction = header['action'] || 'unknown';

    // Check header fields.
    const target = header['target'];
    if (target === undefined) return fail('header.target');
    const action = header['action'];
    if (action === undefined) return fail('header.action');
    const tag = header['tag'];
    if (tag === undefined) return fail('header.tag');
    const source = header['source'];
    if (source === undefined) return fail('header.source');
    const schemaVersion = header['schemaVersion'];
    if (schemaVersion === undefined) return fail('header.schemaVersion');
    const timestamp = header['timestamp'];
    if (timestamp === undefined) return fail('header.timestamp');
    const user = header['user'];
    if (user === undefined) return fail('header.user');
    const isReply = header['isReply'];
    if (isReply === undefined) return fail('header.isReply');

    // Check header.user fields
    // const id = user['id'];
    // if(id === undefined) return fail('header.user.id');
    // const auth = user['auth'];
    // if(auth === undefined) return fail('header.user.auth');
  } catch (err) {
    console.error('Failed to validate message:', err);
    return undefined;
  }
  return messageObj;
};

// import { hostValidators } from './host';
// import { cameraValidators } from './camera';
// import { PlaycastMessage, PlaycastMessageTarget } from '../types/messages';
// import { PlaycastMessageCameraSetResolution } from '../types/messages/camera';

// export const PlaycastMessageValidators = {
//   host: hostValidators,
//   camera: cameraValidators,
// };

// export type PlaycastMessageValidationResponse = {
//   success: boolean;
//   error?: string;
// }

// export const validateMessage = (message: string | PlaycastMessage<PlaycastMessageTarget>): PlaycastMessageValidationResponse => {
//   // Don't even think of using this yet, you bum
//   // If message is a string, parse it to a JSON object

//   // Is the JSON object a PlaycastMessage?

//   // Is the header valid?

//   // Is target/action/isReply a valid combination? (Maybe part of header validation)

//   // Is the message in the body valid for the target/action/isReply?
//   const playcastMessage = message as unknown as PlaycastMessage<PlaycastMessageCameraSetResolution>;

//   if (PlaycastMessageValidators['camera']['setResolution']['request'](playcastMessage)) {
//     // Is valid
//   }

//   return { success: true };
// }
